import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/slg/index'
import hdcrm from '@/views/slg/hdcrm'
import yxhdcrm from '@/views/slg/yxhdcrm'
import h5crm from '@/views/slg/h5crm'
import pmr from '@/views/slg/pmr'
import scrm from '@/views/slg/scrm'
import cube from '@/views/slg/cube'
import datacrm from '@/views/slg/datacrm'
import caseList from '@/views/aoveras/caseList'
import about from '@/views/aoveras/about'
import login from '@/views/aoveras/login'
import zhchkpt from '@/views/ychy/zhchkpt'



const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
    scrollBehavior(to, from, saveTop) {
        if (saveTop) {
            return saveTop;
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes: [
        {
            path: '/',
            name: 'index',
            component: index,
            meta: {
                keepAlive: true,
                title:'首页'
            },
        },
        {
            path: '/yxhdcrm',
            name: 'yxhdcrm',
            component: yxhdcrm,
            meta: {
                keepAlive: true
            },
        },
        {
            path: '/hdcrm',
            name: 'hdcrm',
            component: hdcrm,
            meta: {
                keepAlive: true
            },
        },
        {
            path: '/h5crm',
            name: 'h5crm',
            component: h5crm,
            meta: {
                keepAlive: true
            },
        },
        {
            path: '/pmr',
            name: 'pmr',
            component: pmr,
            meta: {
                keepAlive: true
            },
        },
        {
            path: '/scrm',
            name: 'scrm',
            component: scrm,
            meta: {
                keepAlive: true
            },
        },
        {
            path: '/cube',
            name: 'cube',
            component: cube,
            meta: {
                keepAlive: true
            },
        },
        {
            path: '/datacrm',
            name: 'datacrm',
            component: datacrm,
            meta: {
                keepAlive: true
            },
        },
        {
            path: '/caseList',
            name: 'caseList',
            component: caseList,

        },
        {
            path: '/about',
            name: 'about',
            component: about,

        },
        {
            path: '/login',
            name: 'login',
            component: login,

        },
        {
            path: '/zhchkpt',
            name: 'zhchkpt',
            component: zhchkpt
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js